// extracted by mini-css-extract-plugin
export default {"container":"UQE2J2","icon":"a64D0D","text":"Y4SZzM"};